const render = (type = 0) => {
  switch (type) {
    case 1:
      return (
        <div className="lds-circle">
          <div></div>
        </div>
      );
    case 2:
      return <div className="lds-dual-ring"></div>;
    case 3:
      return (
        <div className="lds-facebook">
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    case 4:
      return (
        <div className="lds-heart">
          <div></div>
        </div>
      );
    case 5:
      return (
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    case 6:
      return (
        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    case 7:
      return (
        <div className="lds-default">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    case 8:
      return (
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    case 9:
      return (
        <div className="lds-grid">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    default:
      return (
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
  }
};

const Loading = ({ type }) => {
  return <div className="omg-loading">{render(type)}</div>;
};

export default Loading;
